import React from 'react'
import Hero3D from '../components/Hero3D.'
import Sponsors from '../components/Sponsors'
import Klubovi from '../components/Klubovi'
import MapSection from '../components/MapSection'

const Naslovna = () => {
  return (
    <div className='container'>
      <Hero3D />
      <Sponsors />
      <Klubovi />
      <MapSection />
      
    </div>
  )
}

export default Naslovna
